<template>
  <div class="grid grid-cols-12 gap-4">
    <div class="col-span-12">
      <div class="grid grid-cols-12 gap-4 mx-auto">
        <div class="col-span-12">
          <form>
            <div v-if="errorMessage" class="bg-red-50 border border-red-400 text-red-700 px-4 py-3 rounded mb-3">
              {{ errorMessage }}
            </div>
            <select v-model="form.groupId" class="w-full px-3 py-2 text-sm border border-gray-300 rounded bg-white focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent">
                <option v-for="(option, idx) in groupData" :key="option.value ?? `group-${idx}`" :value="option.value">{{ option.text }}</option>
            </select>
            <input type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent my-2" v-model="form.name"
              placeholder="Permission Name"
              required />
            <textarea
              data-test="role-description"
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent my-2"
              v-model="form.description"
              placeholder="Description"
              rows="4"
            ></textarea>
            <button class="btn-primary bg-primary text-white px-2 py-1 rounded-sm hover:bg-primary-dark" type="button" @click="submitPermission">
              Save Permission
              <span class="lds-ring" v-if="spinner">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </span>
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch, onMounted } from 'vue'
import { useStore } from 'vuex'

interface PermissionForm {
    groupId: string | null
    name: string | null
    description: string | null
    enabled: boolean
    permissions: string[]
}

interface GroupOption {
    text: string
    value: string | null
}

interface Permission {
    id: string
    name: string
}

interface Props {
    roleData?: any
}

const props = withDefaults(defineProps<Props>(), {
    roleData: () => ({})
})

const store = useStore()

const errorMessage = ref<string | null>(null)
const checkPermissions = ref(false)
const form = ref<PermissionForm>({
    groupId: null,
    name: null,
    description: null,
    enabled: true,
    permissions: []
})
const groupData = ref<GroupOption[]>([])
const spinner = ref(false)
const role_uid = ref<string | null>(null)
const permissions = ref<Permission[]>([])
const allPermissions = ref<string[]>([])
const permissionsToRemove = ref<string[]>([])

onMounted(() => {
    errorMessage.value = ""
    store.dispatch("fetchPermissionGroups")
    store.dispatch("fetchPermissions")
})

const submitPermission = () => {
    spinner.value = true
    errorMessage.value = null
    store.dispatch("addPermission", form.value)
}

// Watchers
watch(() => store.getters.getPermissionGroupsList, (rolesGroup) => {
    if (rolesGroup) {
        console.log(rolesGroup)
        groupData.value = [
            {
                text: "- Select Group -",
                value: null
            }
        ]
        for (let i = 0; i < rolesGroup.length; i++) {
            groupData.value.push({
                text: rolesGroup[i].name,
                value: rolesGroup[i].id
            })
        }
    }
})

watch(() => store.getters.getRolesError, (rolesError) => {
    if (rolesError) {
        spinner.value = false
        errorMessage.value = rolesError.message
        // @ts-ignore
        errorToast("Error", rolesError.message)
    }
})

watch(() => store.getters.getPermissionList, (permissionList) => {
    permissions.value = permissionList
})

watch(() => store.getters.getRolesAndPermissionUpdate, (roleDataUpdate) => {
    if (roleDataUpdate) {
        // @ts-ignore
        successToast("Success", "Role updated successfully")
        form.value.permissions = []
        permissionsToRemove.value = []
        form.value.name = null
        form.value.description = null
        role_uid.value = null
        // @ts-ignore
        emit("finished", true)
        store.dispatch("fetchRoles")
        store.dispatch("fetchPermissionGroups")
        store.dispatch("fetchPermissions")
    }
})

watch(() => store.getters.getNewPermission, (data) => {
    if (data) {
        // @ts-ignore
        successToast()
        groupData.value = []
        spinner.value = false
        role_uid.value = null
        permissions.value = []
        allPermissions.value = []
        permissionsToRemove.value = []
        form.value = {
            groupId: null,
            name: null,
            description: null,
            enabled: true,
            permissions: []
        }
        store.dispatch("fetchPermissionGroups")
        store.dispatch("fetchPermissions")
    }
})
</script>
